import { LegalEntitiesIdentitiesService_legalEntitiesQueryServiceV2PostExternalToLegalEntityId } from '@festina/legalentity-general-types/legalentity/hooks/LegalEntitiesIdentitiesService_legalEntitiesQueryServiceV2PostExternalToLegalEntityId'

export const useFetchInternalId =
  LegalEntitiesIdentitiesService_legalEntitiesQueryServiceV2PostExternalToLegalEntityId.useSuspenseQuery
